module.exports = __webpack_public_path__ + "img/safe-connected.96b32744.jpg";